if (!customElements.get('card-product')) {
  class CardProduct extends HTMLElement {
    constructor() {
      super();

      if (this.classList.contains('disabled')) {
        return;
      }

      this.swatches = this.querySelector('.js-swatches');
      this.btnToggleSizes = this.querySelector(
        '.js-btn-toggle-sizes'
      );
      this.defaultMedia = this.querySelector('.js-media-default');

      this.quickDropdown = this.querySelector('.card-product__quick-dropdown');
      if (this.quickDropdown) {
        this.cartDrawer = document.querySelector('cart-drawer');

        this.quickSelect = this.quickDropdown.querySelector('.card-product__quick-select');
        this.quickDropdownSubmit = this.quickDropdown.querySelector('.card-product__quick-dropdown-submit');
        this.quickDropdownProxy = this.quickDropdown.querySelector('.card-product__quick-dropdown-proxy');

        if (this.quickSelect) {
          this.quickSelectTrigger = this.quickSelect.querySelector('.card-product__quick-select-trigger');
          this.quickSelectValue = this.quickSelect.querySelector('.card-product__quick-select-value');
          this.quickSelectList = this.quickSelect.querySelector('.card-product__quick-select-list');
          this.quickSelectOptions = [...this.quickSelect.querySelectorAll('.card-product__quick-select-option')];
          this.quickSelectedValue = '';

          const closeQuickSelect = () => {
            this.quickSelectList.hidden = true;
            this.quickSelectTrigger.setAttribute('aria-expanded', 'false');
          };

          const openQuickSelect = () => {
            this.quickSelectList.hidden = false;
            this.quickSelectTrigger.setAttribute('aria-expanded', 'true');
          };

          const chooseOption = option => {
            if (option.classList.contains('is-disabled')) return;
            this.quickSelectOptions.forEach(o => {
              o.classList.remove('is-active');
              o.setAttribute('aria-selected', 'false');
            });
            option.classList.add('is-active');
            option.setAttribute('aria-selected', 'true');
            this.quickSelectValue.textContent = option.getAttribute('data-value');
            this.quickSelectedValue = option.getAttribute('data-value');
            this.quickDropdownSubmit.disabled = false;
            closeQuickSelect();
            this.quickSelectTrigger.focus();
          };

          this.quickSelectTrigger.addEventListener('click', () => {
            if (this.quickSelectList.hidden) {
              openQuickSelect();
            } else {
              closeQuickSelect();
            }
          });

          this.quickSelectTrigger.addEventListener('keydown', e => {
            if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              openQuickSelect();
              const firstEnabled = this.quickSelectOptions.find(o => !o.classList.contains('is-disabled'));
              firstEnabled?.focus();
            }
          });

          this.quickSelectOptions.forEach((option, index) => {
            option.addEventListener('click', () => chooseOption(option));

            option.addEventListener('keydown', e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                chooseOption(option);
              } else if (e.key === 'Escape') {
                closeQuickSelect();
                this.quickSelectTrigger.focus();
              } else if (e.key === 'ArrowDown') {
                e.preventDefault();
                this.quickSelectOptions[index + 1]?.focus();
              } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                if (index === 0) {
                  closeQuickSelect();
                  this.quickSelectTrigger.focus();
                } else {
                  this.quickSelectOptions[index - 1]?.focus();
                }
              }
            });
          });

          document.addEventListener('click', e => {
            if (!this.quickSelect.contains(e.target)) {
              closeQuickSelect();
            }
          });

          this.quickDropdownSubmit.addEventListener('click', () => {
            if (!this.quickSelectedValue) return;
            const proxyBtn = this.quickDropdownProxy.querySelector(
              `.js-btn-size[data-size="${CSS.escape(this.quickSelectedValue)}"]`
            );
            if (proxyBtn) {
              this.handleBtnSizeClick({ target: proxyBtn });
            }
          });
        } else if (this.quickDropdownSubmit) {
          // No size option on this product - the button itself is the size button
          this.quickDropdownSubmit.addEventListener('click', () => {
            this.handleBtnSizeClick({ target: this.quickDropdownSubmit });
          });
        }
      }

      if (this.btnToggleSizes) {
        this.cartDrawer = document.querySelector('cart-drawer');

        this.duplicateSizes();
        this.setAccessibility();

        this.initialSizeBtns =
          this.sizesContent.querySelectorAll('.js-btn-size');
        this.duplicateSizeBtns =
          this.duplicatedSizesContent.querySelectorAll(
            '.js-btn-size'
          );
        this.sizeBtns = [
          ...this.initialSizeBtns,
          ...this.duplicateSizeBtns
        ];

        if (this.swatches) {
          this.swatches.addEventListener('click', e => {
            const variantId = e.target.getAttribute('data-variant');

            if (variantId) {
              const closestProductCardMedia = e.target.closest('.relative')?.querySelector('.card-product__media');
              const closestProductCardContent = e.target.closest('card-product').querySelector('.card-product__content');

              if (closestProductCardMedia && closestProductCardMedia.tagName === 'A') {
                const currentUrlMedia = closestProductCardMedia.href.split('?')[0];
                const newUrlMedia = currentUrlMedia + '?variant=' + variantId;
                closestProductCardMedia.href = newUrlMedia;
              }

              if (closestProductCardContent) {
                const currentUrlContent = closestProductCardContent.href.split('?')[0];
                const newUrlContent = currentUrlContent + '?variant=' + variantId;
                closestProductCardContent.href = newUrlContent;
              }
            }
          });
        }

        this.btnToggleSizes.addEventListener('click', e => {
          e.preventDefault();

          if (!this.duplicatedSizesContainer) {
            return;
          }

          const btnId = this.btnToggleSizes.dataset.id;
          const sizesContent =
            this.duplicatedSizesContainer.querySelector(
              `.js-sizes-content[data-id="${btnId}"]`
            );

          this.showSizes(sizesContent);
        });

        this.duplicatedSizesContent.addEventListener('click', e => {
          const isSizesContent = e.target.classList.contains(
            'js-sizes-content'
          );

          if (!isSizesContent) {
            return;
          }

          const sizesContent = e.target;

          this.hideSizes(sizesContent);
        });

        this.duplicatedSizesContent.addEventListener('keydown', e => {
          const isEscape = e.key === 'Escape';

          if (!isEscape) {
            return;
          }

          this.hideSizes(this.duplicatedSizesContent);
        });

        this.duplicatedSizesContent.addEventListener('keydown', e => {
          const isTabKey = e.key === 'Tab';

          if (!isTabKey) {
            return;
          }

          const isFirstElementFocused =
            document.activeElement === this.firstFocusableElement;
          const isLastElementFocused =
            document.activeElement === this.lastFocusableElement;

          if (e.shiftKey && isFirstElementFocused) {
            this.lastFocusableElement.focus();

            e.preventDefault();
          } else if (!e.shiftKey && isLastElementFocused) {
            this.firstFocusableElement.focus();

            e.preventDefault();
          }
        });

        window.addEventListener('resize', () => {
          const isSizeContentVisible =
            this.duplicatedSizesContent.classList.contains(
              'is-visible'
            );
          const hasHover = matchMedia('(hover: hover)').matches;

          if (DeviceDetector.isMobile() || !isSizeContentVisible || !hasHover) {
            return;
          }

          this.hideSizes(this.duplicatedSizesContent);
        });

        this.sizesContent.addEventListener(
          'click',
          this.handleBtnSizeClick.bind(this)
        );
        this.duplicatedSizesContent.addEventListener(
          'click',
          this.handleBtnSizeClick.bind(this)
        );
      }

      if (this.swatches) {
        this.btnSwatches =
          this.swatches.querySelectorAll('.js-btn-swatch');

        this.swatches.addEventListener('change', e => {
          this.querySelector('.card-product__media')?.classList.add('is-transitioning');

          const isBtnSwatch =
            e.target.classList.contains('js-btn-swatch');

          if (!isBtnSwatch) {
            return;
          }

          const btnSwatch = e.target;
          const isSwatchActive =
            btnSwatch.classList.contains('is-active');

          if (isSwatchActive) {
            return;
          }

          const btnSwatchColor = btnSwatch.dataset.color;
          const btnSwatchColorHandle = btnSwatch.dataset.colorHandle;
          const btnSwatchColorHyphenated = btnSwatchColorHandle.toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/-$/, '')
            .replace(/^-/, '');

          const activeBtnSwatch = this.swatches.querySelector(
            '.js-btn-swatch.is-active'
          );

          const currentVisibleMedia = this.querySelector(
            '[class*="js-media"].is-visible'
          );
          const newVisibleMedia = this.querySelector(
            `.js-media-${btnSwatchColorHyphenated}`
          );

          activeBtnSwatch?.classList.remove('is-active');
          btnSwatch?.classList.add('is-active');

          if (newVisibleMedia) {
            currentVisibleMedia.classList.remove('is-visible');
            newVisibleMedia.classList.add('is-visible');
          } else if (this.defaultMedia) {
            currentVisibleMedia.classList.remove('is-visible');
            this.defaultMedia.classList.add('is-visible');
          }

          if (!this.btnToggleSizes && !this.quickDropdownProxy) {
            return;
          }

          const isRequesting =
            this.classList.contains('is-requesting');

          if (isRequesting) {
            return;
          }

          if (this.btnToggleSizes) {
            const sizeMessagesContainer =
              this.sizesContent.querySelector(
                '.js-messages.is-visible'
              );

            sizeMessagesContainer?.classList.remove('is-visible');
          }

          this.toggleBtns();

          this.querySelector('.card-product__media')?.classList.remove('is-transitioning');

          const applySizeAvailability = (sizeBtn, matchingColorVariants, product) => {
            const size = sizeBtn.dataset.size;

            let matchingSizeVariant;
            const shouldAutoSelectVariant = sizeBtn.classList.contains('js-first-available-variant');
            if (shouldAutoSelectVariant) {
              const firstMatchingColorVariant = matchingColorVariants.find(
                variant => variant.available
              );

              if (firstMatchingColorVariant) {
                matchingSizeVariant = firstMatchingColorVariant;
              }
            } else if (matchingColorVariants.length == 1) {
              matchingSizeVariant = matchingColorVariants.find(
                matchingColorVariant =>
                  product.variants.some(
                    variant =>
                      variant.options.includes(size) &&
                      variant.color === matchingColorVariant.color
                  )
              );
            } else {
              matchingSizeVariant = matchingColorVariants.find(
                matchingColorVariant =>
                  matchingColorVariant.options.includes(size)
              );
            }

            const isAvailable = !!(matchingSizeVariant && matchingSizeVariant.available);

            if (isAvailable) {
              sizeBtn.setAttribute('aria-disabled', false);
              sizeBtn.classList.remove('is-disabled');
              if (matchingColorVariants.length == 1 || shouldAutoSelectVariant) {
                sizeBtn.setAttribute(
                  'data-variantid',
                  matchingSizeVariant.id
                );
                sizeBtn.setAttribute(
                  'data-size',
                  matchingSizeVariant.options[0]
                );
                sizeBtn.setAttribute(
                  'title',
                  matchingSizeVariant.title
                );
              }
            } else {
              sizeBtn.setAttribute('aria-disabled', true);
              sizeBtn.classList.add('is-disabled');
            }

            return isAvailable;
          };

          const updateAvailableSizes = async () => {
            try {
              const product = await this.getProduct();

              const matchingColorVariants = product.variants.filter(
                variant =>
                  variant.options.some(option => option == btnSwatchColor)
              );

              if (this.sizeBtns) {
                this.sizeBtns.forEach(sizeBtn =>
                  applySizeAvailability(sizeBtn, matchingColorVariants, product)
                );
              }

              if (this.quickDropdownProxy) {
                const availabilityBySize = new Map();

                this.quickDropdownProxy.querySelectorAll('.js-btn-size').forEach(sizeBtn => {
                  const size = sizeBtn.dataset.size;
                  const isAvailable = applySizeAvailability(sizeBtn, matchingColorVariants, product);
                  availabilityBySize.set(size, isAvailable);
                });

                this.quickSelectOptions?.forEach(option => {
                  const value = option.getAttribute('data-value');
                  const isAvailable = availabilityBySize.get(value);

                  if (isAvailable === false) {
                    option.classList.add('is-disabled');
                    option.setAttribute('aria-disabled', 'true');
                  } else {
                    option.classList.remove('is-disabled');
                    option.removeAttribute('aria-disabled');
                  }
                });

                if (
                  this.quickSelectedValue &&
                  availabilityBySize.get(this.quickSelectedValue) === false
                ) {
                  this.quickSelectedValue = '';
                  this.quickSelectValue.textContent = this.quickSelectValue.dataset.placeholder;
                  this.quickSelectOptions?.forEach(o => {
                    o.classList.remove('is-active');
                    o.setAttribute('aria-selected', 'false');
                  });
                  if (this.quickDropdownSubmit) {
                    this.quickDropdownSubmit.disabled = true;
                  }
                }
              }
            } catch (error) {
              console.error(error);
            } finally {
              this.toggleBtns();
            }
          };

          updateAvailableSizes();
        });
      }

      this.initVideoAutoplay();
    }

    // Product cards can show a Shopify-hosted video as their cover media
    // (see snippets/card-product.liquid). Autoplaying every card's video the
    // moment the collection page loads would download/decode dozens of
    // videos at once, so playback is gated behind visibility instead: play
    // muted while the card is on screen, pause as soon as it scrolls away.
    initVideoAutoplay() {
      const video = this.querySelector('.card-product__media--video video');
      if (!video) return;

      const observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.25 }
      );

      observer.observe(video);
    }

    async getProduct() {
      try {
        const productResponse = await fetch(
          `${window.Shopify.routes.root}products/${this.dataset.handle}.js`
        );

        const product = await productResponse.json();

        return product;
      } catch (error) {
        console.error(error);
      }
    }

    duplicateSizes() {
      this.sizesContent = this.querySelector('.js-sizes-content');
      this.duplicatedSizesContent = this.sizesContent.cloneNode({
        deep: true
      });
      this.duplicatedSizesContainer = document.querySelector(
        '.js-card-sizes-duplicate'
      );

      this.focusableElements = getFocusableElements(
        this.duplicatedSizesContent
      );

      this.firstFocusableElement = this.focusableElements[0];
      this.lastFocusableElement =
        this.focusableElements[this.focusableElements.length - 1];

      if (!this.duplicatedSizesContainer) {
        this.duplicatedSizesContainer = document.createElement('div');
        this.duplicatedSizesContainer.classList.add(
          'js-card-sizes-duplicate'
        );

        document.body.insertAdjacentElement(
          'beforeend',
          this.duplicatedSizesContainer
        );
      }

      this.duplicatedSizesContainer.insertAdjacentElement(
        'beforeend',
        this.duplicatedSizesContent
      );
    }

    handleBtnSizeClick(e) {
      const isBtnSize = e.target.classList.contains('js-btn-size');

      if (!isBtnSize) {
        return;
      }

      const btnSize = e.target;
      const isDisabled = btnSize.classList.contains('is-disabled');
      const isRequesting = this.classList.contains('is-requesting');

      if (isRequesting || isDisabled) {
        return;
      }

      const btnSwatchActive = this.querySelector(
        '.js-btn-swatch.is-active'
      );

      const selectedSize = btnSize.dataset.size;
      const selectedColor = btnSwatchActive?.dataset.color;

      const selectedVariantId = btnSize.dataset.variantid
        ? btnSize.dataset.variantid
        : undefined;

      const targetSizesContent = btnSize.closest('.js-sizes-content');
      const sizeMessagesContainer =
        targetSizesContent.querySelector('.js-messages');
      const sizeMessageSuccess = targetSizesContent.querySelector(
        '.js-success-message'
      );
      const sizeMessageError = targetSizesContent.querySelector(
        '.js-error-message'
      );

      this.toggleBtns();

      const addProductToCart = async () => {
        try {
          const product = await this.getProduct();

          const matchingVariant = product.variants.find(variant => {
            if (selectedVariantId) {
              const matchesVariantId =
                variant.id == selectedVariantId;
              return matchesVariantId;
            } else {
              const matchesSize =
                variant.options.includes(selectedSize);
              const matchesColor = btnSwatchActive
                ? variant.options.includes(selectedColor)
                : true;
              return matchesSize && matchesColor;
            }
          });

          if (!matchingVariant) {
            return;
          }

          const isAvailable = matchingVariant.available;

          if (!isAvailable) {
            return;
          }

          const formData = new FormData();
          formData.append('id', matchingVariant.id);
          formData.append('quantity', 1);
          if (this.hasAttribute('data-has-pre-order')) {
            formData.append('properties[Pre-order]', '✓');
          }
          formData.append(
            'sections',
            this.cartDrawer
              .getSectionsToRender()
              ?.map(section => section.section)
          );

          // if we are on the cart page, resubmit form
          if (window.location.pathname === '/cart') {
            const cartDrawerForm = document.getElementById(
              'CartDrawer-FormSummary'
            );
            if (cartDrawerForm) {
              cartDrawerForm.submit();
            }
          }

          let sectionsToRender = [];
          if (this.cartDrawer && typeof this.cartDrawer.getSectionsToRender === 'function') {
            sectionsToRender = this.cartDrawer.getSectionsToRender()?.map(s => s.section) || [];
          } else {
            const mainCartItems = document.getElementById('main-cart-items');
            if (mainCartItems && mainCartItems.dataset && mainCartItems.dataset.id) {
              sectionsToRender.push(mainCartItems.dataset.id);
            }
            sectionsToRender.push('cart-counter');
          }

          formData.append('sections', sectionsToRender);
          formData.append('sections_url', window.location.pathname);

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          config.body = formData;

          const addToCartResponse = await fetch(
            `${routes.cart_add_url}`,
            config
          );

          const addToCartData = await addToCartResponse.json();

          if (!addToCartResponse.ok) {
            throw new Error(addToCartData.description);
          }

          sizeMessageSuccess.classList.remove('hidden');
          sizeMessageError.classList.add('hidden');

          if (this.cartDrawer && typeof this.cartDrawer.renderContents === 'function') {
            this.cartDrawer.renderContents(addToCartData, true);
          }
          if (window.location.pathname === '/cart' || !this.cartDrawer) {
            try {
              const sections = sectionsToRender;
              sections.forEach(sectionId => {
                const sectionHtml = addToCartData.sections?.[sectionId];
                if (!sectionHtml) return;
                const selector = `#shopify-section-${sectionId} cart-items`;
                const containerBySelector = document.querySelector(selector);
                const containerById = document.querySelector(`#shopify-section-${sectionId}`);

                if (containerBySelector) {
                  containerBySelector.innerHTML = new DOMParser()
                    .parseFromString(sectionHtml, 'text/html')
                    .querySelector(selector).innerHTML;
                } else if (containerById) {
                  containerById.innerHTML = new DOMParser()
                    .parseFromString(sectionHtml, 'text/html')
                    .querySelector(`#shopify-section-${sectionId}`).innerHTML;
                } else {
                  const possible = document.querySelector(`[data-id="${sectionId}"]`);
                  if (possible) {
                    const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
                    const extracted = parsed.querySelector(`[data-id="${sectionId}"]`);
                    if (extracted)
                      possible.innerHTML = extracted.innerHTML;
                  }
                }
              });

              document.dispatchEvent(
                new CustomEvent('cart:updated', {
                  detail: addToCartData
                })
              );
            } catch (replaceError) {
              console.error(replaceError);
            }
          }
        } catch (error) {
          const errorTextEl =
            sizeMessageError.querySelector('[data-text]');

          sizeMessageSuccess.classList.add('hidden');
          sizeMessageError.classList.remove('hidden');

          errorTextEl.textContent = error.message;
        } finally {
          this.toggleBtns();

          sizeMessagesContainer.classList.add('is-visible');
          setTimeout(() => {
            sizeMessagesContainer.classList.remove('is-visible');
          }, 4000);

          // Remove is-visible class on mobile after adding product to cart
          if (DeviceDetector.isMobile()) {
            this.duplicatedSizesContent.classList.remove('is-visible');
            if (this.cartDrawer?.classList.contains('is-visible')) {
              return;
            }
            document.body.classList.remove('overflow-hidden');
          }
        }
      };

      addProductToCart();
    }

    setAccessibility() {
      const duplicatedSizesContentId = `SizesPopup-${this.sizesContent.dataset.id}`;

      this.duplicatedSizesContent.id = duplicatedSizesContentId;
      this.btnToggleSizes.setAttribute('aria-expanded', false);
      this.btnToggleSizes.setAttribute(
        'aria-controls',
        duplicatedSizesContentId
      );
    }

    toggleBtns() {
      this.classList.toggle('is-requesting');
      this.btnSwatches?.forEach(btnSwatch =>
        btnSwatch.toggleAttribute('disabled')
      );

      if (!this.btnToggleSizes) {
        return;
      }

      this.sizesContent.classList.toggle('overlay-visible');
      this.duplicatedSizesContent.classList.toggle('overlay-visible');
    }

    showSizes(container) {
      this.btnToggleSizes.setAttribute('aria-expanded', true);
      container.classList.add('is-visible');
      document.body.classList.add('overflow-hidden');
      this.firstFocusableElement.focus();
    }

    hideSizes(container) {
      this.btnToggleSizes.setAttribute('aria-expanded', false);
      container.classList.remove('is-visible');
      document.body.classList.remove('overflow-hidden');
      this.btnToggleSizes.focus();
    }
  }

  customElements.define('card-product', CardProduct);
}
